































































































import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
// 风控设置appId和超时时间
// @ts-ignore
const neg = createNEGuardian({ appId: "YD00346551221340", timeout: 10000 });
@Component({})
export default class PfLogin extends Vue {
  @Action("user/login") public login!: any;

  private form: Form = {
    loginName: "",
    loginPwd: "",
    isVerifyCode: "1",
    verifyCode: "",
    agentCode: "",
    taskId: "",
    inviteCode: "",
  };
  private showWXwork: any = 1;
  private showqq: any = 1;
  private checked = true;
  private timeCount = 0;
  private timer: any = null;
  private isShowCount = false;
  private controlToken: any = null;
  private antiShake: any = false;
  private handleToEmit(componentName: any) {
    this.$emit("goto", componentName);
  }
  private handleToWxWork() {
    // const str: any = this.$route.query.redirect;
    // console.log(str);
    const agentCode: any =
      sessionStorage.getItem("LONGYIXIU_agentCode") || null;
    const taskId: any = sessionStorage.getItem("LoginTaskId") || null;
    const inviteCode: any = sessionStorage.getItem("LoginInviteCode") || null;
    let appid = "wwb049ab06b49ac01a";
    if (this.$subName == "longyixiu") {
      appid = "wwb049ab06b49ac01a";
    } else if (this.$subName == "wenjuanjia") {
      appid = "ww8f1a67fc0e39b46a";
    }
    const owurl = `https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=${appid}&usertype=member&redirect_uri=https://${
      window.location.host
    }/auth?${agentCode ? "&agentCode=" + agentCode : ""}${
      taskId ? "&taskId=" + taskId : ""
    }${inviteCode ? "&inviteCode=" + inviteCode : ""}& redirect=${
      this.$route.query.redirect || ""
    }`; // 获取微信扫描登录地址
    const tmp: any = window.open("about:blank", "", "fullscreen=1");
    tmp.moveTo(0, 0); // 指定窗口开始位置（左上角）
    tmp.resizeTo(1024, 720); // 指定窗口结束位置（右下角）
    tmp.focus();
    tmp.location = owurl;
  }
  private getControlToken() {
    const that = this;
    setTimeout(() => {
      neg.getToken().then((result: any) => {
        if (result.code === 200) {
          // 正常情况
          that.controlToken = result.token;
        }
        if (result.code === 201) {
          // 离线模式
          that.controlToken = result.token;
        }
      });
    }, 200);
  }
  private handleToQQ() {
    // const str: any = this.$route.query.redirect;
    // console.log(str);
    const agentCode: any =
      sessionStorage.getItem("LONGYIXIU_agentCode") || null;
    const taskId: any = sessionStorage.getItem("LoginTaskId") || null;
    const inviteCode: any = sessionStorage.getItem("LoginInviteCode") || null;
    let client_id = "102016843";
    if (this.$subName == "longyixiu") {
      client_id = "102016843";
    } else if (this.$subName == "wenjuanjia") {
      client_id = "102612587";
    }
    const owurl = `https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=${client_id}&state=1&redirect_uri=https://${
      window.location.host
    }/auth?${agentCode ? "&agentCode=" + agentCode : ""}${
      taskId ? "&taskId=" + taskId : ""
    }${inviteCode ? "&inviteCode=" + inviteCode : ""}&redirect=${
      this.$route.query.redirect || ""
    }`; // 获取微信扫描登录地址
    const tmp: any = window.open("about:blank", "", "fullscreen=1");
    tmp.moveTo(0, 0); // 指定窗口开始位置（左上角）
    tmp.resizeTo(1024, 720); // 指定窗口结束位置（右下角）
    tmp.focus();
    tmp.location = owurl;
  }
  private remember(event: any) {
    console.log(event);
    if (event) {
      // 记住密码
      this.$tool.setCookie("remember", event, 365);
    }
  }
  private async getVerifyCode() {
    if (this.antiShake) {
      return false;
    }
    this.antiShake = true;
    let currentTimestamp = new Date().getTime();
    let saveTimestamp: any = 0;
    saveTimestamp = localStorage.getItem("ST")
      ? localStorage.getItem("ST")
      : -1;
    if (!this.form.loginName) {
      this.$message.warning("手机号码不能为空");
      return false;
    } else if (!/^1[3456789]\d{9}$/.test(this.form.loginName)) {
      this.$message.warning("请输入正确的手机号码！");
      return false;
    } else if (saveTimestamp > 0 && currentTimestamp - saveTimestamp < 60000) {
      this.$message.warning("发送验证码频繁，请稍后再试");
      return false;
    } else {
      this.$apis
        .getVerifyCode({
          phone: this.form.loginName,
          verifyCode: "0000",
          type: "1",
          controlToken: this.controlToken,
          channelType: 1,
          isControl: 1,
        })
        .then(() => {
          // 重新获取controlToken，防止提交重复的controlToken
          this.getControlToken();
          this.handleCount(60);
          this.antiShake = false;
          localStorage.setItem("ST", currentTimestamp + "");
        })
        .catch(() => {
          // 重新获取controlToken，防止提交重复的controlToken
          this.getControlToken();
          this.antiShake = false;
        });
    }
  }
  private handleCount(count: number) {
    if (!this.timer) {
      this.timeCount = count;
      this.isShowCount = true;
      this.timer = setInterval(() => {
        if (this.timeCount > 0 && this.timeCount <= count) {
          this.timeCount--;
        } else {
          this.isShowCount = false;
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    }
  }
  private async handleLogin() {
    if (!this.form.loginName) {
      this.$message.warning("手机号不能为空");
      return false;
    } else if (!/^1[3456789]\d{9}$/.test(this.form.loginName)) {
      this.$message.warning("请输入正确的手机号码！");
      return false;
    } else if (!this.form.verifyCode) {
      this.$message.warning("验证码不能为空");
      return false;
    } else {
      try {
        this.form.agentCode =
          sessionStorage.getItem("LONGYIXIU_agentCode") || "";
        const res = await this.login(this.form);
        const str: any = this.$route.query.redirect;
        if (str) {
          this.$router.replace(str);
        } else {
          this.$router.replace("/activeManagement.html");
        }
        // this.$router.push("/voting/list");
        this.$message.success("登录成功");
      } catch (error) {
        console.log(error);
      }
    }

    /*
    // if (this.form.loginName && this.form.loginPwd) {
    if (this.form.loginName && this.form.verifyCode) {
      // if (!this.checked) {
      //   this.$message.warning("请选择《服务协议》和《隐私政策》");
      //   return;
      // }
      try {
        this.form.agentCode =
          sessionStorage.getItem('LONGYIXIU_agentCode') || ''
        const res = await this.login(this.form)
        const str: any = this.$route.query.redirect
        if (str) {
          this.$router.replace(str)
        } else {
          this.$router.replace('/activeManagement.html')
        }
        // this.$router.push("/voting/list");
        this.$message.success('登录成功')
      } catch (error) {
        console.log(error)
      }
    } else {
      this.$message.warning('手机号或验证码不能为空')
    }
    */
  }
  private async created() {
    document.title = "登录_" + this.$globalName;
    this.getControlToken();
  }
}

interface Form {
  loginName: string;
  loginPwd: string;
  isVerifyCode: string;
  verifyCode: string;
  agentCode: string;
  inviteCode: string;
  taskId: string;
}
